/*
const styles = [
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        color: '#e9e9e9',
      },
      {
        lightness: 17,
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'geometry',
    stylers: [
      {
        color: '#f5f5f5',
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 17,
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 29,
      },
      {
        weight: 0.2,
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 18,
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [
      {
        color: '#f5f5f5',
      },
      {
        lightness: 21,
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [
      {
        color: '#dedede',
      },
      {
        lightness: 21,
      },
    ],
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [
      {
        visibility: 'on',
      },
      {
        color: '#ffffff',
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    elementType: 'labels.text.fill',
    stylers: [
      {
        saturation: 36,
      },
      {
        color: '#333333',
      },
      {
        lightness: 40,
      },
    ],
  },
  {
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [
      {
        color: '#f2f2f2',
      },
      {
        lightness: 19,
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#fefefe',
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#fefefe',
      },
      {
        lightness: 17,
      },
      {
        weight: 1.2,
      },
    ],
  },
];
*/

function getMaps() {
  return document.querySelectorAll('.js-google-map');
}

function setupRegularMap(map) {
  const lat = parseFloat(map.dataset.mapLat);
  const lng = parseFloat(map.dataset.mapLong);
  const zoom = parseInt(map.dataset.mapZoom);
  const url = map.dataset.mapUrl;

  const mapPosition = {
    lat,
    lng,
  };

  /* eslint-disable no-undef */
  const googleMap = new google.maps.Map(map, {
    center: mapPosition,
    zoom,
    disableDefaultUI: true,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
  });

  // googleMap.setOptions({ styles });

  const customMarker = new google.maps.MarkerImage(
    '/images/pin.svg',
    null /* size is determined at runtime */,
    null /* origin is 0,0 */,
    new google.maps.Point(
      30,
      60
    ) /* anchor is bottom center of the scaled image */,
    new google.maps.Size(60, 60) /* Size given in CSS Length units */
  );

  // eslint-disable-next-line no-unused-vars
  const marker = new google.maps.Marker({
    position: mapPosition,
    map: googleMap,
    icon: customMarker,
  });

  google.maps.event.addListener(marker, 'click', function () {
    window.open(url, '_blank');
  });
  /* eslint-enable no-undef */
}

function setupMultiMap(map) {
  const zoom = parseInt(map.dataset.mapZoom);

  const markerEls = map.querySelectorAll('.js-map-marker');
  const markers = [];

  /* eslint-disable no-undef */
  const googleMap = new google.maps.Map(map, {
    // center: mapPosition,
    zoom,
    disableDefaultUI: true,
    zoomControl: true,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
  });

  // googleMap.setOptions({ styles });

  markerEls.forEach((marker, index) => {
    const markerPosition = {
      lat: parseFloat(marker.dataset.lat),
      lng: parseFloat(marker.dataset.lng),
    };

    if (index === 0) {
      googleMap.setCenter(markerPosition);
    }

    const markerIcon = {
      url: '/images/pin-navy-outline-blue.svg',
      size: null /* size is determined at runtime */,
      origin: new google.maps.Point(0, 0),
      anchor: new google.maps.Point(
        16,
        48
      ) /* anchor is bottom center of the scaled image */,
      scaledSize: new google.maps.Size(
        32,
        48
      ) /* Size given in CSS Length units */,
    };

    // eslint-disable-next-line no-unused-vars
    markers.push({
      position: markerPosition,
      map: googleMap,
      icon: markerIcon,
    });
  });

  const bounds = new google.maps.LatLngBounds();

  markers.forEach((marker, index) => {
    // eslint-disable-next-line no-new
    const mapMarker = new google.maps.Marker(marker);

    const markerUrl = markerEls[index].dataset.url;

    if (markerUrl) {
      mapMarker.addListener('click', ({ domEvent, latLng }) => {
        window.location.href = markerUrl;
      });
    }

    bounds.extend(marker.position);
  });

  googleMap.fitBounds(bounds);

  /* eslint-enable no-undef */
}

window.initMaps = function () {
  // activate all maps
  const maps = getMaps();

  if (maps.length) {
    for (let i = 0; i < maps.length; i++) {
      const map = maps[i];

      if (map.classList.contains('js-google-map-multi')) {
        setupMultiMap(map);
      } else {
        setupRegularMap(map);
      }
    }
  }
};
